import { MedicalTestResults } from "../../components";


const MedicalTestResultsPage= () =>{
    return (<MedicalTestResults/>)
}

export default MedicalTestResultsPage;